import { z } from 'zod';
import config from '@/config';

export type ErrorContextType = z.infer<typeof ErrorContextSchema>;
export type ErrorPageNameType = z.infer<typeof ErrorPageNameSchema>;

export enum ErrorCodes {
  BadRequest = 400,
  NotFound = 404,
  InternalServerError = 500,
}
export const ErrorPageNameSchema = z.enum([
  config.PAGE_NAMES.LANDING,
  config.PAGE_NAMES.LISTING,
  config.PAGE_NAMES.AGENCY,
  config.PAGE_NAMES.COMPANY_AGENCY,
  config.PAGE_NAMES.AGENT,
  config.PAGE_NAMES.LOGIN,
  config.PAGE_NAMES.CURRENT_NEWS,
  config.PAGE_NAMES.CAREER_STORIES,
]);

export const ErrorContextSchema = z.object({
  errorCode: z.nativeEnum(ErrorCodes).optional(),
  errorPageName: ErrorPageNameSchema.optional(),
  targetUrl: z.string().optional(),
});
